module.exports = __webpack_public_path__ + "img/reverse-side.51dc5bdf.png";